import { useEffect, useState } from "react";
import Accordion from "react-bootstrap/esm/Accordion";
import Card from "react-bootstrap/esm/Card";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import LoadingComp from "../../components/re-usable/loading/loading";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import PageNotFound from "../errors/page-not-found";
import { retrieveAccordion } from "../../redux/slice/accordion-slice";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../redux/store";
import Banner from "./components/europe-2024-banner";

const Europe2024Index = () => {
  const { "*": urlPath } = useParams();
  const formattedPath = urlPath?.replaceAll("/", "%2F");

  const path = `%2Feurope-2024%2F${formattedPath}`;
  const accordionPath = `${path}%2FAccordion-Items`;

  const dispatch = useAppDispatch();
  const { RapsEuropeData: pageMenuData, RapsEuropeLoading: pageMenuLoading, pageNotFound } = useSelector((state: RootState) => state.rapsEurope);
  const { AccordionData } = useSelector((state: RootState) => state.Accordion);

  const [isPublished, setIsPublished] = useState(false);
  const [scriptHtmlString, setScriptHtmlString] = useState("");
  const [isPageNotFound, setIsPageNotFound] = useState(!pageMenuLoading && pageNotFound);

  useEffect(() => {
    dispatch(retrievePageMenu(path));
    dispatch(retrieveAccordion(accordionPath));
  }, [dispatch]);

  useEffect(() => {
    if (pageMenuData[0]?.result) {
      setIsPublished(true);
    }
    else if (!pageMenuLoading && pageNotFound) {
      setIsPageNotFound(true);
    }
  }, [pageMenuData]);

  useEffect(() => {
    if (isPublished) {
      if (pageMenuData[0].result[0]?.javaScriptField)
        setScriptHtmlString(pageMenuData[0].result[0]?.javaScriptField);
    }
  }, [isPublished])

  useDynamicScripts({ htmlScriptString: scriptHtmlString });

  if (isPageNotFound) return <PageNotFound />;
  if (!isPublished) return <LoadingComp />;

  return (
    <>
      <EuropeStyleComponent />
      <Helmet>
        <title>{pageMenuData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <Banner
        bannerImage={pageMenuData[0]?.result[0]?.mainHeaderImage}
        mobileBanner={pageMenuData[0]?.result[0]?.mobileHeaderImage}
        headerText={pageMenuData[0]?.result[0]?.headerText}
        topCommonMesage={pageMenuData[0]?.result[0]?.topCommonMesage}
      />
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.description }}></div>
      <div className="container">
        <Accordion alwaysOpen flush className="convergence convergence-primary">
          {AccordionData[0]?.data?.map((item, index) => {
            return (
              <Card>
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Card.Header>
                    <Accordion.Header className="btn btn-block heading">
                      <span className="heading">
                        <strong dangerouslySetInnerHTML={{ __html: item.name }}></strong>
                        <i aria-hidden="true" className="fa fa-angle-double-down" id="fa-angle-arrow">
                          &nbsp;
                        </i>
                      </span>
                    </Accordion.Header>
                  </Card.Header>
                  <Accordion.Body dangerouslySetInnerHTML={{ __html: item.description }}></Accordion.Body>
                </Accordion.Item>
              </Card>
            );
          })}
        </Accordion>
      </div>
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.councilDescription }}></div>
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.popupContent }}></div>
    </>
  );
};

export default Europe2024Index;

const EuropeStyleComponent = () => {
  return (
    <>
      <style>
        {`
        `}
      </style>
    </>
  );
};
